import { useTranslation } from 'react-i18next';
import { ButtonLink } from '@anytag/shared-atoms';
import { useAllTalentAgencyCompanyQuery } from '@anytag/graphql';
import { Header, ListWithPagination } from '@anytag/shared-molecules';
import { getOffset, getValuableVariables } from '@anytag/shared-utils';
import { useTalentAgencyPermissions, useUserRoles } from '@anytag/auth';
import { useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { TalentAgenciesFilter, TalentAgenciesList, useAccountsFilter } from '@anytag/shared-organisms';

export const TalentAgencies = () => {
  useUpdateDocumentTitle({ title: 'appHeader.Talent Agency', appHeader: 'appHeader.Talent Agency' });
  const { t } = useTranslation();
  const { isAdmin } = useUserRoles();
  const { page, limit, filter } = useAccountsFilter();
  const { hideAddTalentAgencyBtn } = useTalentAgencyPermissions();
  const { data, previousData, loading } = useAllTalentAgencyCompanyQuery({
    fetchPolicy: 'network-only',
    variables: getValuableVariables({
      ...filter,
      limit,
      offset: getOffset(page, limit),
      verifiedStatus: filter.verifiedStatus || null
    })
  });

  const result = loading ? previousData : data;
  const totalRecords = result?.allTalentAgenciesCount?.totalNumber;

  return (
    <div>
      <Header>
        {isAdmin && !hideAddTalentAgencyBtn ? (
          <ButtonLink
            variant="solid"
            to="/talent-agency/add"
            className="ml-auto min-w-27 capitalize"
            title={t('Button.Add Talent Agency')}
            prefixIcon={{ icon: 'plus', size: '10px' }}
          />
        ) : null}
      </Header>

      <ListWithPagination pagination={{ totalRecords }}>
        <TalentAgenciesFilter />
        <TalentAgenciesList loading={loading} totalRecords={totalRecords} data={result?.allTalentAgencyCompany || []} />
      </ListWithPagination>
    </div>
  );
};
